import { ActivityType } from '@/features/course/admin/types/activity';

export type DrawerItemTypeV2 = ActivityType | 'completed';

export const ACTIVITY_TYPE_TO_ICON = {
  [ActivityType.Page]: ['far', 'rectangle'],
  [ActivityType.Result]: ['far', 'party-horn'],
  completed: ['far', 'circle-check'],
  [ActivityType.Question]: ['far', 'square-poll-vertical'],
  [ActivityType.PracticalAssessmentText]: ['far', 'pen-line'],
  [ActivityType.PracticalAssessmentDocument]: ['far', 'pen-line'],
  [ActivityType.PracticalAssessmentVideo]: ['far', 'pen-line'],
  [ActivityType.Reflection]: ['far', 'comment-pen'],
  [ActivityType.Module]: ['far', 'rectangle-history'],
  [ActivityType.Quiz]: ['far', 'game-board-simple'],
  [ActivityType.Assignment]: ['far', 'pen-line'],
};
